import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/styles.module.scss';
import { ContributeButton } from './contribute_button';
import { ModalFunnelUtil } from '../../../../utils/modal_funnel_util';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import StarInactive from '../../../../../assets/images/icons/inactive-sml.svg';
import StarRating from '../../../../components/shared/StarRating';
import { addToList, removeFromList } from '../../../../utils/requests/list_requests';
import { toATLocalString } from '../../../../utils/number_util';

class TrailUgcBar extends React.Component {
  getRecordingFormProps() {
    const { trailId } = this.props;

    return {
      trailId,
      showSmoothOption: true,
      url: '/api/alltrails/maps/gpx'
    };
  }

  getPhotoFormProps() {
    const url = `/api/alltrails/trails/${this.props.trailId}/photos?key=${ServerCommunicationUtil.apiKey}`;
    return { url, exploreFlag: false };
  }

  getReviewFormProps() {
    const { trailId, trailName, loggedInUserId } = this.props;
    return {
      trailId,
      trailName,
      user: {
        id: loggedInUserId
      },
      comment: '',
      rating: null,
      activity: {
        name: '',
        type: 'activity',
        uid: ''
      },
      multistep: true
    };
  }

  getTrailFormProps(tabName) {
    switch (tabName) {
      case 'reviews':
        return this.getReviewFormProps();
      case 'photos':
        return this.getPhotoFormProps();
      case 'tracks':
        return this.getRecordingFormProps();
      default:
        return null;
    }
  }

  openTrailFormModal(tabName) {
    const trailFormProps = this.getTrailFormProps(tabName);
    this.props.openTrailFormModal(tabName, trailFormProps);
  }

  handleClick(tabName) {
    if (!this.props.loggedInUserId) {
      const returnToUrl = window.location.pathname + window.location.search;
      ModalFunnelUtil.modalSignup(null, `trail-contribute-${tabName}`, returnToUrl);
      return;
    }

    return this.openTrailFormModal(tabName);
  }

  handleAddToCompletedClick() {
    if (!this.props.currentUserId) {
      const returnToUrl = window.location.pathname + window.location.search;
      ModalFunnelUtil.modalSignup(null, 'trail-more-completed', returnToUrl);
      return;
    }

    const completedMagicId = 1001;
    const userId = null; // aka Me
    if (this.props.completedConnectionId) {
      removeFromList(completedMagicId, this.props.completedConnectionId, userId)
        .then(listItem => this.handleCompletedRemoved(listItem))
        .catch(err => this.handleCompletedRemovedError(this.props.completedConnectionId, err));
      ServerCommunicationUtil.handleGaqPush(['_trackEvent', 'Trail Page', 'Action Bar', 'Completed Removed']);
    } else {
      addToList(completedMagicId, 'trail', this.props.trailId, userId)
        .then(listItem => this.handleCompletedAdded(listItem))
        .catch(error => this.handleCompletedAddedError(error));
      ServerCommunicationUtil.handleGaqPush(['_trackEvent', 'Trail Page', 'Action Bar', 'Completed Added']);
    }
  }

  handleCompletedAdded(listItem) {
    this.props.messagingChannel.publish({
      topic: 'listItem.added',
      data: {
        listItem
      }
    });
    if (this.props.handleCompletedConnectionChanged) {
      this.props.handleCompletedConnectionChanged(listItem.id);
    }
  }

  handleCompletedAddedError(error) {
    throw `There was an error adding the trail to your completed list ${error}`;
  }

  handleCompletedRemoved(listItem) {
    this.props.messagingChannel.publish({
      topic: 'listItem.removed',
      data: {
        listItem
      }
    });
    if (this.props.handleCompletedConnectionChanged) {
      this.props.handleCompletedConnectionChanged(null);
    }
  }

  handleCompletedRemovedError(listItemId, error) {
    throw `There was an error removing the trail from your completed list ${error}`;
  }

  renderReviewsGraph() {
    const ratingCounts = this.props.ratingsBreakdown;
    if (Object.keys(ratingCounts).length < 1) {
      return null;
    }

    let averageRating = null;
    let ratingsTable = null;
    const nonZeroRatingCount = this.props.itemCount;
    const ratingSum = Object.keys(ratingCounts)
      .map(i => ratingCounts[i] * i)
      .reduce((a, b) => a + b);
    if (nonZeroRatingCount > 0) {
      const displayText =
        nonZeroRatingCount == 1
          ? StringConstantsMixin.strings.REVIEW_SINGULAR
          : StringConstantsMixin.strings.REVIEWS_PLURAL.replace('{count}', toATLocalString(nonZeroRatingCount, this.props.locale));
      const rating = (ratingSum / nonZeroRatingCount).toFixed(1);
      averageRating = (
        <div className={styles.rating}>
          <div className={styles.ratingDisplay}>{rating}</div>
          <StarRating config={rating} />
          <div className={styles.ratingCount}>{displayText}</div>
        </div>
      );

      const rows = [];
      let largestRatingCount = 0;
      Object.keys(ratingCounts).forEach(i => {
        if (ratingCounts[i] > largestRatingCount) {
          largestRatingCount = ratingCounts[i];
        }
      });
      for (let i = 5; i >= 1; i--) {
        rows.push(
          <tr key={`ratings-${i}`}>
            <td className={styles.label}>{i}</td>
            <td className={styles.star}>
              <img src={StarInactive} />
            </td>
            <td className={styles.graphBar}>
              <div style={{ width: `${ratingCounts[i] ? (ratingCounts[i] * 100.0) / largestRatingCount : 0}%` }} />
            </td>
          </tr>
        );
      }
      ratingsTable = (
        <div className={styles.ratingsTable}>
          <table>
            <tbody>{rows}</tbody>
          </table>
        </div>
      );
    }
    return (
      <div className={styles.reviewsMobile}>
        {ratingsTable}
        {averageRating}
      </div>
    );
  }

  renderInvitation() {
    if (!this.props.showInvitation) {
      return;
    }

    switch (this.props.activeTab) {
      case 'photos':
        return (
          <div className='invitationContainer'>
            <h5 className="label">{StringConstantsMixin.strings.ADD_YOUR_PHOTOS}</h5>
            <p>{StringConstantsMixin.strings.PHOTOS_HELP_OTHERS}</p>
          </div>
        );
      case 'tracks':
        return (
          <div className='invitationContainer'>
            <h5 className="label">{StringConstantsMixin.strings.SHARE_YOUR_ROUTE}</h5>
            <p>{StringConstantsMixin.strings.RECORDINGS_HELP_OTHERS}</p>
          </div>
        );
      case 'reviews':
        return this.renderReviewsGraph();
      case 'completed':
        const templateString =
          this.props.itemCount == 0
            ? StringConstantsMixin.strings.USE_RECORDER_ZERO
            : this.props.itemCount == 1
            ? StringConstantsMixin.strings.USE_RECORDER_SINGULAR
            : StringConstantsMixin.strings.USE_RECORDER_PLURAL;
        const paragraphText = templateString.replace('{completedCount}', this.props.itemCount);
        return (
          <div className='invitationContainer'>
            <h5 className="label">{StringConstantsMixin.strings.JOIN_THE_LIST}</h5>
            <p>{paragraphText}</p>
          </div>
        );
      default:
        return null;
    }
  }

  renderButton() {
    if (!this.props.showContributeButton) {
      return;
    }

    const gaqArr = ['_trackEvent', 'Trail Profile', 'Trail Feed']; // this will eventually be passed in
    switch (this.props.activeTab) {
      case 'photos':
        return <ContributeButton contributeType="photo" clickHandler={() => this.handleClick('photos')} gaqArray={gaqArr} />;
      case 'tracks':
        return <ContributeButton contributeType="track" clickHandler={() => this.handleClick('tracks')} gaqArray={gaqArr} />;
      case 'reviews':
        return <ContributeButton contributeType="review" clickHandler={() => this.handleClick('reviews')} gaqArray={gaqArr} />;
      case 'completed':
        return (
          <ContributeButton
            contributeType="completed"
            clickHandler={() => this.handleAddToCompletedClick()}
            gaqArray={gaqArr}
            completedConnectionId={this.props.completedConnectionId}
          />
        );
    }
  }

  render() {
    if (!this.props.loggedInUserId) {
      return null;
    }

    const activeDiv = this.renderButton();
    const paddingClass = 'show-button';
    const invitationDiv = this.renderInvitation();

    return (
      <div className={`upload-ugc-button-holder ${paddingClass}`}>
        {invitationDiv}
        {activeDiv}
        {this.props.ugcSortDropDown}
      </div>
    );
  }
}

TrailUgcBar.propTypes = {
  activeTab: PropTypes.string.isRequired,
  completedConnectionId: PropTypes.number,
  currentUserId: PropTypes.number,
  items: PropTypes.array,
  loadMore: PropTypes.func.isRequired,
  loggedInUserId: PropTypes.number,
  messagingChannel: PropTypes.object,
  shouldReload: PropTypes.func,
  trailId: PropTypes.number.isRequired,
  trailName: PropTypes.string,
  ugcSortDropDown: PropTypes.object,
  showContributeButton: PropTypes.bool,
  showInvitation: PropTypes.bool
};

TrailUgcBar.defaultProps = {
  showContributeButton: true,
  showInvitation: true
};

export { TrailUgcBar };
